import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _extends from "@babel/runtime/helpers/extends";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import * as React from 'react';
import styled from 'styled-components';
import { TableCell, TableRow, IconButton, Checkbox, Tooltip, useTheme } from '@material-ui/core';
import Icon from '../Icon';
import { StyledStickyCell, isGetActionData } from './index';
import { Cell } from './Cell';

var useMasterDetail = function useMasterDetail(_ref) {
  var uniqueId = _ref.uniqueId,
      dsRenderMasterDetail = _ref.dsRenderMasterDetail;
  var isUsingWebcomponents = React.useRef(false);
  var masterDetailRef = React.useRef(null);
  var masterDetailParentRef = React.useRef();

  var _React$useState = React.useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      isMasterDetailOpen = _React$useState2[0],
      setIsMasterDetailOpen = _React$useState2[1];

  var toggleMasterDetail = function toggleMasterDetail() {
    if (!isUsingWebcomponents.current && !dsRenderMasterDetail) {
      return;
    }

    if (!!isUsingWebcomponents.current) {
      var collection = document.getElementsByTagName('ds-table-master-detail');
      var masterDetailNode = Array.from(collection).find(function (row) {
        var _ref2;

        return ((_ref2 = row) === null || _ref2 === void 0 ? void 0 : _ref2.uniqueKey) === uniqueId;
      });

      if (!masterDetailParentRef.current && (masterDetailNode === null || masterDetailNode === void 0 ? void 0 : masterDetailNode.parentElement)) {
        masterDetailParentRef.current = masterDetailNode.parentElement;
      }

      if (masterDetailRef.current && masterDetailNode) {
        masterDetailRef.current.appendChild(masterDetailNode);
      } // if master detail is about to be visible


      if (!isMasterDetailOpen === true) {
        masterDetailNode.show();
      }
    }

    setIsMasterDetailOpen(!isMasterDetailOpen);
  };

  React.useEffect(function () {
    if (!!document.getElementsByTagName('ds-table-master-detail').length) {
      isUsingWebcomponents.current = true;
    }

    return function () {
      if (isUsingWebcomponents.current && masterDetailParentRef.current) {
        var _masterDetailRef$curr;

        var child = (_masterDetailRef$curr = masterDetailRef.current) === null || _masterDetailRef$curr === void 0 ? void 0 : _masterDetailRef$curr.firstChild;

        if (child) {
          child.hide();
          masterDetailParentRef.current.appendChild(child);
        }
      }
    };
  }, []);
  return {
    isUsingWebcomponents: isUsingWebcomponents,
    toggleMasterDetail: toggleMasterDetail,
    isMasterDetailOpen: isMasterDetailOpen,
    masterDetailRef: masterDetailRef,
    isMasterDetailClickable: !!isUsingWebcomponents.current || !!dsRenderMasterDetail
  };
};

var StyledTableRow = styled(TableRow).withConfig({
  displayName: "Row__StyledTableRow",
  componentId: "sc-1vcm4q6-0"
})(["transform:scale(1);visibility:", ";& td{cursor:", ";}td:nth-child(2){padding-left:", "px;}"], function (_ref3) {
  var _ref3$$visible = _ref3.$visible,
      $visible = _ref3$$visible === void 0 ? true : _ref3$$visible;
  return $visible ? 'visible' : 'hidden';
}, function (_ref4) {
  var $isclickable = _ref4.$isclickable;
  return $isclickable ? 'pointer' : 'auto';
}, function (_ref5) {
  var $indentlevel = _ref5.$indentlevel;
  return "".concat(16 + $indentlevel * 16);
});
var StyledMasterDetailTableRow = styled(TableRow).withConfig({
  displayName: "Row__StyledMasterDetailTableRow",
  componentId: "sc-1vcm4q6-1"
})(["@keyframes delayedHide{to{visibility:hidden;}}", ""], function (_ref6) {
  var $visible = _ref6.$visible;
  return $visible ? 'visibility: visible;' : 'animation: 0s linear 250ms forwards delayedHide;';
});
var StyledActionsWrapper = styled.div.withConfig({
  displayName: "Row__StyledActionsWrapper",
  componentId: "sc-1vcm4q6-2"
})(["display:flex;justify-content:right;"]);
var StyledMasterDetail = styled(TableCell).withConfig({
  displayName: "Row__StyledMasterDetail",
  componentId: "sc-1vcm4q6-3"
})(["border-bottom:", " !important;& div{display:block;overflow:hidden;max-height:", ";transition:max-height 250ms ease-in-out;}"], function (_ref7) {
  var $expanded = _ref7.$expanded;
  return $expanded ? 'auto' : 0;
}, function (_ref8) {
  var $expanded = _ref8.$expanded;
  return $expanded ? '500px' : '0px';
});
export var Row = function Row(_ref9) {
  var dense = _ref9.dense,
      e2e = _ref9.e2e,
      hasOverflow = _ref9.hasOverflow,
      overflowColor = _ref9.overflowColor,
      columns = _ref9.columns,
      colSpan = _ref9.colSpan,
      rowActions = _ref9.rowActions,
      row = _ref9.row,
      rows = _ref9.rows,
      nestedRowsMap = _ref9.nestedRowsMap,
      editableRow = _ref9.editableRow,
      uniqueKey = _ref9.uniqueKey,
      nestedDataKey = _ref9.nestedDataKey,
      _ref9$indentLevel = _ref9.indentLevel,
      indentLevel = _ref9$indentLevel === void 0 ? 0 : _ref9$indentLevel,
      isEditable = _ref9.isEditable,
      isSelected = _ref9.isSelected,
      isSelectable = _ref9.isSelectable,
      dsRenderMasterDetail = _ref9.dsRenderMasterDetail,
      dsIsRowSelectable = _ref9.dsIsRowSelectable,
      dsIsCellEditable = _ref9.dsIsCellEditable,
      onCheckboxClick = _ref9.onCheckboxClick,
      onInputChange = _ref9.onInputChange,
      onToggleRowEdit = _ref9.onToggleRowEdit,
      dsCustomRowEditAction = _ref9.dsCustomRowEditAction;

  // TODO: lift to parent so we can use to compute pagination / rows in view
  var _React$useState3 = React.useState(false),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      showChildren = _React$useState4[0],
      setShowChildren = _React$useState4[1];

  var uniqueId = row[uniqueKey];
  var isItemSelected = isSelected(uniqueId);
  var rowChildren = nestedRowsMap[uniqueId];
  var isEditableRow = !!editableRow && editableRow[uniqueKey] === uniqueId;
  var hasActions = !!(rowActions === null || rowActions === void 0 ? void 0 : rowActions.length);
  var isRowSelectable = !!dsIsRowSelectable ? dsIsRowSelectable({
    row: row,
    children: rowChildren
  }) : true;

  var _useMasterDetail = useMasterDetail({
    uniqueId: uniqueId,
    dsRenderMasterDetail: dsRenderMasterDetail
  }),
      toggleMasterDetail = _useMasterDetail.toggleMasterDetail,
      isMasterDetailOpen = _useMasterDetail.isMasterDetailOpen,
      masterDetailRef = _useMasterDetail.masterDetailRef,
      isMasterDetailClickable = _useMasterDetail.isMasterDetailClickable,
      isUsingWebcomponents = _useMasterDetail.isUsingWebcomponents; // check the custom edit action to see if the row should be editable


  var renderEditAction = dsCustomRowEditAction ? dsCustomRowEditAction.dsIsActionVisible({
    row: row
  }) : true;
  var theme = useTheme();
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(StyledTableRow, {
    tabIndex: -1,
    "aria-checked": isItemSelected,
    $indentlevel: indentLevel,
    onClick: toggleMasterDetail,
    $isclickable: isMasterDetailClickable ? 'true' : ''
  }, !!nestedDataKey && /*#__PURE__*/React.createElement(TableCell, {
    size: dense ? 'small' : 'medium',
    padding: "checkbox"
  }, !!rowChildren && /*#__PURE__*/React.createElement(IconButton, _extends({}, e2e && {
    'data-e2e': "".concat(e2e, "-expandCollapseAction")
  }, {
    color: "primary",
    size: "small",
    onClick: function onClick() {
      return setShowChildren(!showChildren);
    },
    style: {
      width: 40,
      height: 40,
      transform: "rotate(".concat(showChildren ? '90deg' : '0deg', ")"),
      transition: 'transform 0.1s linear'
    }
  }), /*#__PURE__*/React.createElement(Icon, {
    body: "chevron_right"
  }))), isSelectable && /*#__PURE__*/React.createElement(TableCell, {
    padding: "checkbox",
    style: {
      width: 'auto'
    }
  }, isRowSelectable && /*#__PURE__*/React.createElement(Checkbox, {
    color: "primary",
    checked: isItemSelected,
    onClick: function onClick(e) {
      e.stopPropagation();
      onCheckboxClick(row, uniqueId);
    },
    inputProps: _objectSpread({}, e2e && {
      'data-e2e': "".concat(e2e, "-checkbox")
    })
  })), columns.map(function (column, columnIndex) {
    if (column.hidden) return null;
    var value = isEditableRow ? editableRow === null || editableRow === void 0 ? void 0 : editableRow[column.field] : row[column.field];
    var isCellEditable = dsIsCellEditable ? dsIsCellEditable({
      column: column,
      row: row,
      value: value
    }) && isEditableRow : isEditableRow;
    return /*#__PURE__*/React.createElement(Cell, _extends({
      dense: dense // Column width is included in key to force re-mounting to re-compute
      // cell overflow to conditionally display tooltips
      ,
      key: "table-body-row-column-".concat(columnIndex, "-").concat(column.width)
    }, e2e && {
      e2e: "".concat(e2e, "-col-").concat(column.field)
    }, {
      value: value,
      column: column,
      uniqueKey: uniqueKey,
      uniqueValue: uniqueId,
      isEditable: isCellEditable,
      editableRowUniqueValue: editableRow && String(editableRow[uniqueKey]),
      onInputChange: onInputChange
    }));
  }), /*#__PURE__*/React.createElement(StyledStickyCell, {
    $hasOverflow: hasOverflow,
    $overflowColor: overflowColor
  }, /*#__PURE__*/React.createElement(StyledActionsWrapper, null, isEditable && renderEditAction && /*#__PURE__*/React.createElement(IconButton, _extends({}, e2e && {
    'data-e2e': "".concat(e2e, "-saveOrEditAction")
  }, {
    color: "primary",
    size: "small",
    style: {
      width: 40,
      height: 40
    },
    onClick: function onClick(e) {
      e.stopPropagation();
      var toggleFn = isEditableRow ? dsCustomRowEditAction === null || dsCustomRowEditAction === void 0 ? void 0 : dsCustomRowEditAction.dsUseDefaultSave : dsCustomRowEditAction === null || dsCustomRowEditAction === void 0 ? void 0 : dsCustomRowEditAction.dsUseDefaultEdit;

      if (toggleFn) {
        var shouldToggle = toggleFn({
          row: row
        });

        if (shouldToggle) {
          onToggleRowEdit(row);
        }

        return;
      }

      onToggleRowEdit(row);
    }
  }), /*#__PURE__*/React.createElement(Icon, {
    body: isEditableRow ? 'save' : 'edit'
  })), hasActions && rowActions.map(function (action, actionIndex) {
    var actionData = isGetActionData(action) ? action.dsGetActionData(row) : action; // if there is no actionData it means we should render nothing

    if (!actionData) {
      return null;
    }

    var icon = actionData.icon,
        _onClick = actionData.onClick,
        id = actionData.id,
        disabled = actionData.disabled,
        tooltip = actionData.tooltip;
    return /*#__PURE__*/React.createElement(Tooltip, {
      key: "table-action-".concat(actionIndex),
      arrow: true,
      title: tooltip || '',
      PopperProps: _objectSpread(_objectSpread({}, e2e && {
        'data-e2e': "".concat(e2e, "-action-").concat(id || icon, "-tooltip")
      }), {}, {
        modifiers: {
          offset: {
            enabled: true,
            offset: "0, -".concat(theme.spacing(1))
          }
        }
      })
    }, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(IconButton, _extends({}, e2e && {
      'data-e2e': "".concat(e2e, "-action-").concat(id || icon)
    }, {
      color: "primary",
      size: "small",
      style: {
        width: 40,
        height: 40
      },
      disabled: disabled || false,
      onClick: function onClick(e) {
        e.stopPropagation();
        _onClick === null || _onClick === void 0 ? void 0 : _onClick({
          row: row
        });
      }
    }), icon && /*#__PURE__*/React.createElement(Icon, {
      body: icon,
      color: disabled ? 'disabled' : 'action'
    }))));
  })))), dsRenderMasterDetail || isUsingWebcomponents.current ? /*#__PURE__*/React.createElement(StyledMasterDetailTableRow, _extends({
    $visible: isMasterDetailOpen
  }, !isMasterDetailOpen && {
    'aria-hidden': true
  }), /*#__PURE__*/React.createElement(StyledMasterDetail, {
    colSpan: colSpan,
    $expanded: isMasterDetailOpen ? 'true' : '',
    padding: "none"
  }, /*#__PURE__*/React.createElement("div", {
    ref: masterDetailRef
  }, dsRenderMasterDetail === null || dsRenderMasterDetail === void 0 ? void 0 : dsRenderMasterDetail({
    row: row
  })))) : null, showChildren && rowChildren.map(function (childRow) {
    return /*#__PURE__*/React.createElement(Row, _extends({}, e2e && {
      e2e: "".concat(e2e, "-child-").concat(childRow[uniqueKey])
    }, {
      key: "table-body-row-child-".concat(childRow[uniqueKey]),
      dense: dense,
      row: childRow,
      rows: rows,
      nestedRowsMap: nestedRowsMap,
      columns: columns,
      colSpan: colSpan,
      rowActions: rowActions,
      editableRow: editableRow,
      uniqueKey: uniqueKey,
      nestedDataKey: nestedDataKey,
      indentLevel: indentLevel + 1,
      isEditable: isEditable,
      isSelected: isSelected,
      isSelectable: isSelectable,
      dsRenderMasterDetail: dsRenderMasterDetail,
      dsIsRowSelectable: dsIsRowSelectable,
      dsIsCellEditable: dsIsCellEditable,
      onCheckboxClick: onCheckboxClick,
      onInputChange: onInputChange,
      onToggleRowEdit: onToggleRowEdit,
      hasOverflow: hasOverflow,
      overflowColor: overflowColor
    }));
  }));
};

try {
  Row.__docgenInfo = {
    description: '',
    displayName: 'Row',
    methods: [],
    props: {
      dense: {
        defaultValue: null,
        description: '',
        name: 'dense',
        required: false,
        type: {
          name: 'boolean'
        }
      },
      e2e: {
        defaultValue: null,
        description: '',
        name: 'e2e',
        required: false,
        type: {
          name: 'string'
        }
      },
      hasOverflow: {
        defaultValue: null,
        description: '',
        name: 'hasOverflow',
        required: false,
        type: {
          name: 'boolean'
        }
      },
      overflowColor: {
        defaultValue: null,
        description: '',
        name: 'overflowColor',
        required: false,
        type: {
          name: 'string'
        }
      },
      columns: {
        defaultValue: null,
        description: '',
        name: 'columns',
        required: true,
        type: {
          name: 'any[]'
        }
      },
      colSpan: {
        defaultValue: null,
        description: '',
        name: 'colSpan',
        required: true,
        type: {
          name: 'number'
        }
      },
      rowActions: {
        defaultValue: null,
        description: '',
        name: 'rowActions',
        required: true,
        type: {
          name: 'any[]'
        }
      },
      row: {
        defaultValue: null,
        description: '',
        name: 'row',
        required: true,
        type: {
          name: 'any'
        }
      },
      rows: {
        defaultValue: null,
        description: '',
        name: 'rows',
        required: true,
        type: {
          name: 'any[]'
        }
      },
      nestedRowsMap: {
        defaultValue: null,
        description: '',
        name: 'nestedRowsMap',
        required: true,
        type: {
          name: '{ [key: string]: any[]; }'
        }
      },
      editableRow: {
        defaultValue: null,
        description: '',
        name: 'editableRow',
        required: false,
        type: {
          name: 'any'
        }
      },
      uniqueKey: {
        defaultValue: null,
        description: '',
        name: 'uniqueKey',
        required: true,
        type: {
          name: 'string'
        }
      },
      nestedDataKey: {
        defaultValue: null,
        description: '',
        name: 'nestedDataKey',
        required: false,
        type: {
          name: 'string'
        }
      },
      indentLevel: {
        defaultValue: {
          value: 0
        },
        description: '',
        name: 'indentLevel',
        required: false,
        type: {
          name: 'number'
        }
      },
      isEditable: {
        defaultValue: null,
        description: '',
        name: 'isEditable',
        required: true,
        type: {
          name: 'boolean'
        }
      },
      isSelected: {
        defaultValue: null,
        description: '',
        name: 'isSelected',
        required: true,
        type: {
          name: '(uniqueValue: string) => boolean'
        }
      },
      isSelectable: {
        defaultValue: null,
        description: '',
        name: 'isSelectable',
        required: true,
        type: {
          name: 'boolean'
        }
      },
      dsRenderMasterDetail: {
        defaultValue: null,
        description: '',
        name: 'dsRenderMasterDetail',
        required: true,
        type: {
          name: 'any'
        }
      },
      dsIsRowSelectable: {
        defaultValue: null,
        description: '',
        name: 'dsIsRowSelectable',
        required: false,
        type: {
          name: 'any'
        }
      },
      dsIsCellEditable: {
        defaultValue: null,
        description: '',
        name: 'dsIsCellEditable',
        required: false,
        type: {
          name: 'any'
        }
      },
      onCheckboxClick: {
        defaultValue: null,
        description: '',
        name: 'onCheckboxClick',
        required: true,
        type: {
          name: '(row: any, value: any) => void'
        }
      },
      onInputChange: {
        defaultValue: null,
        description: '',
        name: 'onInputChange',
        required: true,
        type: {
          name: '(args: { value: any; column: any; }) => void'
        }
      },
      onToggleRowEdit: {
        defaultValue: null,
        description: '',
        name: 'onToggleRowEdit',
        required: true,
        type: {
          name: '(row: any) => void'
        }
      },
      dsCustomRowEditAction: {
        defaultValue: null,
        description: '',
        name: 'dsCustomRowEditAction',
        required: false,
        type: {
          name: 'any'
        }
      }
    }
  };
} catch (e) {}
//# sourceMappingURL=Row.js.map